import type { FieldValues, Path, UseFormReturn } from 'react-hook-form';
import type { FieldValidationError } from '@/lib/api/errors';

const FIELD_ALIASES: Record<string, string> = {
  'membershipConfig.planId': 'membershipPlanId',
  'membershipConfig.grantTierId': 'membershipGrantTierId',
  'displayConfig.hidePrice': 'hidePrice',
  'displayConfig.hideChildren': 'hideChildren',
  'displayConfig.requirePhotos': 'requirePhotos',
  'displayConfig.requireAsset': 'requireAsset',
};

export function applyServerErrorsToForm<TFieldValues extends FieldValues>(
  form: UseFormReturn<TFieldValues>,
  fieldErrors: FieldValidationError[],
): Path<TFieldValues> | null {
  let firstField: Path<TFieldValues> | null = null;

  for (const error of fieldErrors) {
    const mapped = (FIELD_ALIASES[error.field] ?? error.field) as Path<TFieldValues>;
    form.setError(mapped, { type: 'server', message: error.message });
    if (firstField === null) firstField = mapped;
  }

  if (firstField) {
    queueMicrotask(() => {
      try {
        form.setFocus(firstField as Path<TFieldValues>);
      } catch {
        scrollToField(firstField as string);
      }
    });
  }

  return firstField;
}

function scrollToField(name: string) {
  const escaped = typeof CSS !== 'undefined' && CSS.escape ? CSS.escape(name) : name;
  const target = document.querySelector(`[name="${escaped}"]`);
  if (target instanceof HTMLElement) {
    target.scrollIntoView({ behavior: 'smooth', block: 'center' });
    target.focus({ preventScroll: true });
  }
}
